/**
 * index compare
 */
const ready = (callback) => {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

ready(async () => {
    let {Compare} = await import("./compare");
    new Compare({
        tabContentId: 'compareTabContent',
        propertyClassName: 'js-compare-property',
        propertyValueClassName: 'js-compare-value',
        toggleClassName: 'js-compare-show-diffs-only',
        enabled: false,
    });
});

/**
 * compare
 */
const compareMoveLeft = document.querySelectorAll('.compare-move-left');
compareMoveLeft.forEach((moveLeft) => {
    moveLeft.addEventListener('click', function () {
        const parent = moveLeft.closest('.js-compare');

        if (parent) {
            const prevElement = parent.previousElementSibling;

            if (prevElement) {
                swap(parent, prevElement);
            }
        }
    });
});

const compareMoveRight = document.querySelectorAll('.compare-move-right');
compareMoveRight.forEach((moveRight) => {
    moveRight.addEventListener('click', function () {
        const parent = moveRight.closest('.js-compare');

        if (parent) {
            const nextElement = parent.nextElementSibling;

            if (nextElement) {
                swap(parent, nextElement);
            }
        }
    });
});

const swap = (node1, node2) => {
    const afterNode2 = node2.nextElementSibling;
    const parent = node2.parentNode;

    if (node1 === afterNode2) {
        parent.insertBefore(node1, node2);
    } else {
        node1.replaceWith(node2);
        parent.insertBefore(node1, afterNode2);
    }
}

const compareColTop = document.querySelector('.compare-col__top');
const compareColFixed = document.querySelectorAll('.compare-col__fixed');
const compareBoxObserver = new window.IntersectionObserver(function (entries) {
    let entry = entries[0];

    if (!entry.isIntersecting) {
        compareColFixed.forEach(el => {
            el.classList.add('compare-col__fixed--active');
        })
    } else {
        compareColFixed.forEach(el => {
            el.classList.remove('compare-col__fixed--active');
        });
    }
});

if (compareColTop) {
    compareBoxObserver.observe(compareColTop);
}
